import { ContactDetails } from './contact/ContactDetails';
import { ContactForm } from './contact/ContactForm';

const Contact = () => (
  <section data-testid="contact-section" className="relative py-28 lg:py-36 px-6 lg:px-10">
    <div className="max-w-[1300px] mx-auto grid lg:grid-cols-2 gap-14 lg:gap-20">
      <ContactDetails />
      <div className="relative min-w-0"><ContactForm /></div>
    </div>
  </section>
);

export default Contact;